/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useRef, useState } from 'react';
import DragableElement from './DragableElement';
import * as pdfjs from 'pdfjs-dist';
import "pdfjs-dist/build/pdf.worker.entry";
import DocumentAuthorContext from '../../../context/DocumentAuthorContext';

const FormCanvas = ({
    droppedComponents, 
    pageIndex, 
    totalPages,
    handleAddPage,
    setIsModified,
}) => {
    const { formType, selectedFile, formData, handleInitialFormData, pages, setPages, setDroppedComponents, view } = useContext(DocumentAuthorContext);
    const canvasRef = useRef(null);
    const [selectedComponent, setSelectedComponent] = useState(null); // State for the selected component
    const [showModal, setShowModal] = useState(false);
    const [tempComponent, setTempComponent] = useState(null);
    const [error, setError] = useState('');
    const [imageError, setImageError] = useState('');
    const [submitSelected, setSubmitSelected] = useState(false);
    const [pdfCanvasWidth, setPdfCanvasWidth] = useState('');
    const [pdfCanvasHeight, setPdfCanvasHeight] = useState('');

    const hasCheckedVisibilityRef = useRef(false);

    useEffect(() => {
        if (!view) {
            return;
        }
  
        if (!hasCheckedVisibilityRef.current) {} else {
            hasCheckedVisibilityRef.current = false;
        }
    }, [view, droppedComponents]);
    
    /* istanbul ignore next */
    async function renderPdf() {
        try {
            const pdfData = await pdfjsLib.getDocument({ data: new Uint8Array(selectedFile) }).promise;
            const pageDimensions = [];

            for (let pageNum = 1; pageNum <= pdfData.numPages; pageNum++) {
                const page = await pdfData.getPage(pageNum);
                const viewport = page.getViewport({ scale: 1 }); // Use the same scale as in your rendering function
                pageDimensions.push({ width: viewport.width, height: viewport.height });
            }
    
            const canvas = canvasRef.current
            const context = canvas.getContext('2d');
    
            canvas.width = pageDimensions[0].width; // Use the width of the first page
            canvas.height = pageDimensions.reduce((totalHeight, dim) => totalHeight + dim.height, 0);
            setPdfCanvasWidth(canvas.width);
            setPdfCanvasHeight(canvas.height);
            let yOffset = 0;
            for (let pageNum = 1; pageNum <= pdfData.numPages; pageNum++) {
                setTimeout(async() => {
                    const page = await pdfData.getPage(pageNum);
                    const viewport = page.getViewport({ scale: 1 });
                    const pageCanvas = document.createElement('canvas');
                    pageCanvas.height = viewport.height - 2;
                    pageCanvas.width = viewport.width;
                    const pageContext = pageCanvas.getContext('2d');
    
                    await page.render({ canvasContext: pageContext, viewport: viewport }).promise;
    
                    // Draw the page onto the main canvas at the current yOffset
                    context.drawImage(pageCanvas, 0, yOffset);
                
                    yOffset += pageDimensions[pageNum - 1].height + 2; // Add space between pages
                }, [500])
            }
        } catch (error) {
            console.error('Error rendering the PDF', error);
        }
    }

    useEffect(() => {
        if(formType === 'pdf'){
            renderPdf();
        }
    }, [selectedFile, view, formType]);
    return (
        <>
            {formType === 'pdf' && 
                (<div style={{position: 'relative'}} className='canvas-container min-w-[600px] max-w-[800px]'>
                    <canvas id="pdf-canvas" data-testid="pdf-canvas" data-page-number={pageIndex} ref={canvasRef} className="pdf-canvas overflow-auto sidebar max-w-[800px]" width={pdfCanvasWidth} height={pdfCanvasHeight}/>
                    {droppedComponents.map((component, index) => (
                        <div key={index}>
                            <DragableElement
                                index={index}
                                component={component}
                                view={view}
                                onComponentDragStart={(e) => onComponentDragStart(e, index, component?.type)}
                                droppedComponents={droppedComponents}
                                setDroppedComponents={setDroppedComponents}
                                setShowModal={setShowModal}
                                setTempComponent={setTempComponent}
                                tempComponent={tempComponent}
                                setSelectedComponent={setSelectedComponent}
                                pageIndex={pageIndex}
                                formType={formType}
                                pages={pages}
                                setPages={setPages}
                                error={error}
                                setError={setError}
                                handleInitialFormData={handleInitialFormData}
                                selectedComponent={selectedComponent}
                                setSubmitSelected={setSubmitSelected}
                                setImageError={setImageError}
                                formData={formData}
                                showModal={showModal}
                                setIsModified={setIsModified}
                                originalCanvasHeight={pdfCanvasHeight}
                                originalCanvasWidth={pdfCanvasWidth}
                            />
                        </div>
                    ))}
                </div>)}

            {formType === 'custom' && 
            <div data-testid="custom-pdf-canvas" style={{position: 'relative'}} className='canvas-container'>
                <canvas data-page-number={pageIndex} id={`custom-pdf-${pageIndex}`} ref={canvasRef} className="form-canvas overflow-auto sidebar" height="870" width="595" />
                <hr className='bg-transparent h-[5px] border-t-0' />
                {droppedComponents.map((component, index) => (
                    <div key={index}>
                        <DragableElement
                            index={index}
                            component={component}
                            view={view}
                            onComponentDragStart={(e) => onComponentDragStart(e, index, component?.type)}
                            droppedComponents={droppedComponents}
                            setDroppedComponents={setDroppedComponents}
                            setShowModal={setShowModal}
                            setTempComponent={setTempComponent}
                            tempComponent={tempComponent}
                            setSelectedComponent={setSelectedComponent}
                            pageIndex={pageIndex}
                            formType={formType}
                            pages={pages}
                            setPages={setPages}
                            error={error}
                            setError={setError}
                            handleInitialFormData={handleInitialFormData}
                            totalPages={totalPages}
                            handleAddPage={handleAddPage}
                            selectedComponent={selectedComponent}
                            setSubmitSelected={setSubmitSelected}
                            setImageError={setImageError}
                            formData={formData}
                            showModal={showModal}
                            setIsModified={setIsModified}
                            originalCanvasHeight="595"
                            originalCanvasWidth="850"
                        />
                    </div>
                ))}
            </div>
            }
        </>
    );
}

export default FormCanvas;